'use client'

import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { siteNotice } from '../lib/api/site.ts'

// One line every page shows while part of the site is paused: the backend's site notice, through the doorway (v1's
// /api/site_notice, or v2's GET /v2/notice for a visitor the `site_notice` switch puts on v2). Asked once a minute while
// the tab is visible; a failed ask shows nothing (it is a courtesy, never an error of its own). The person's sign-in,
// when there is one, only places them in the switch's group.
const EVERY_MS = 60000

export default function SiteNotice() {
  const [notice, setNotice] = useState(null)
  const { user } = useAuth() ?? {}
  const userRef = useRef(user)
  userRef.current = user

  useEffect(() => {
    let stopped = false
    const ask = async () => {
      if (document.visibilityState !== 'visible') return
      try {
        const signedIn = userRef.current
        const token = signedIn?.getIdToken ? await signedIn.getIdToken() : ''
        const response = await siteNotice(token)
        if (!response.ok) return
        const body = await response.json()
        if (!stopped) setNotice(body?.notice || null)
      } catch {
        // nothing to show
      }
    }
    ask()
    const timer = setInterval(ask, EVERY_MS)
    document.addEventListener('visibilitychange', ask)
    return () => {
      stopped = true
      clearInterval(timer)
      document.removeEventListener('visibilitychange', ask)
    }
  }, [])

  if (!notice) return null
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 top-0 z-[120] bg-amber-400 px-4 py-2 text-center text-sm font-medium text-black shadow-md"
    >
      {notice}
    </div>
  )
}
